/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var modelGet = require('common/util/modelGet');
var BreadcrumbView = require('common/views/BreadcrumbView');
var EntityHeaderBarView = require('../../common/views/EntityHeaderBarView');

var EntityRecordsLocationChangeApplicationView = require('../forms/EntityRecordsLocationChangeApplication/EntityRecordsLocationChangeApplicationView');

var tmplEntityRecordsLocationChangeFormView = require('../templates/EntityRecordsLocationChangeFormView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplEntityRecordsLocationChangeFormView,

  className: 'entity-records-location-change-view container-fluid',

  ui: {
    headerBarContainer: '.header-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    entityRecordsLocationChangeFormContainer: '.entity-records-location-change-form-container'
  },

  regions: {
    headerBarContainer: '@ui.headerBarContainer',
    breadCrumbContainer: '@ui.breadCrumbContainer',
    entityRecordsLocationChangeFormContainer: '@ui.entityRecordsLocationChangeFormContainer'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var booksAndRecords = this.model.get('booksAndRecords');
    var instructionsDocument = this.model.get('instructionsDocument');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');

    this.showChildView(
      'headerBarContainer',
      new EntityHeaderBarView({
        model: new Backbone.Model(this.model.get('entityIdentifiers'))
      })
    );

    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#ext/nondep/dashboard'
          },
          {
            text: entityName,
            link: '#ext/nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'Apply to Edit Books and Records Locations'
          }
        ]
      })
    );

    this.showChildView(
      'entityRecordsLocationChangeFormContainer',
      new EntityRecordsLocationChangeApplicationView({
        model: new Backbone.Model({
          booksAndRecords: booksAndRecords,
          entityId: entityId,
          instructionsDocument: instructionsDocument
        })
      })
    );

    Radio.channel('nd:submit-application').on('submit', function() {
      Radio.channel('navigate').trigger('show:ext:nd:entity-dashboard', entityId);
    });
  }
});
